import React, { useEffect, useState, useRef } from 'react';
//import axios from 'axios';
import '../styles/Settings.css'; // pour les styles du switch animé
import '../styles/styles.css';
//import '../styles/styles2.css';
import {  useLocation, useNavigate } from 'react-router-dom';
import Alert from './Alert';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n'; // chemin à adapter selon ton arborescence
import LanguageSelector from './LanguageSelector';
import api from '../services/api';
import { cleanupAndLogout } from '../services/cleanup';
import TwoFactorSetup from './TwoFactorSetup';
import Disable2FAModal from './Disable2FAModal';
import RecoveryPhraseBackup from './RecoveryPhraseBackup';
import { encryptPrivateKey } from '../utils/e2eeRecovery';
import { signalStore } from '../services/signalStore';


const Settings = ({ socket, prompt}) => {
  const [allowContacts, setAllowContacts] = useState(false);

  const [showEmail, setShowEmail] = useState(true);
  const [showPhone, setShowPhone] = useState(true);
 const [showBirthDate, setShowBirthDate] = useState(true);
const [showBirthDateSimple, setShowBirthDateSimple] = useState(true);

const [showAge, setShowAge] = useState(true);
const [showNotifInvit, setShowNotifInvit] = useState(true);
const [showNotifMessage, setShowNotifMessage] = useState(true);
  const [username, setUsername] = useState('');
  //const [email, setEmail] = useState('');
const [newPassword, setNewPassword] = useState('');
const [initialUsername, setInitialUsername] = useState('');
const [initialPassword] = useState('');
const [passwordErrors, setPasswordErrors] = useState([]);
const [currentPassword, setCurrentPassword] = useState('');

const [showRecoverySetup, setShowRecoverySetup] = useState(false);
const [privateKey, setPrivateKey] = useState(null);
const [hasRecovery, setHasRecovery] = useState(false);

const COMMON_PASSWORDS = [
  'password', '123456', '12345678', 'azerty', 'qwerty',
  'motdepasse', 'password1', '11111111', 'abc123456'
];

const checkPasswordStrength = (pwd) => {
  const errors = [];
  if (pwd.length === 0) { setPasswordErrors([]); return true; } // champ vide = pas de changement demandé
  if (pwd.length < 12) errors.push(t('password.tooShort'));
  if (!/[A-Z]/.test(pwd)) errors.push(t('password.needUppercase'));
  if (!/[a-z]/.test(pwd)) errors.push(t('password.needLowercase'));
  if (!/[0-9]/.test(pwd)) errors.push(t('password.needNumber'));
  if (!/[^A-Za-z0-9]/.test(pwd)) errors.push(t('password.needSpecialChar'));

  const lowerPwd = pwd.toLowerCase();
  if (COMMON_PASSWORDS.some(common => lowerPwd.includes(common))) {
    errors.push(t('password.tooCommon'));
  }
  if (username && lowerPwd.includes(username.toLowerCase())) {
    errors.push(t('password.containsUsername'));
  }
  // Pas de vérification email ici si le champ email n'est pas modifiable dans ce formulaire

  setPasswordErrors(errors);
  return errors.length === 0;
};

const handleNewPasswordChange = (e) => {
  const val = e.target.value;
  setNewPassword(val);
  checkPasswordStrength(val);
};

const [autoTranslate, setAutoTranslate] = useState(true);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
const { t } = useTranslation();
const location = useLocation();
const [toast, setToast] = useState(null);
const showToast = (message, type = 'info') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };
const [savedKey, setSavedKey] = useState(null); // clé du setting sauvegardé
const fromDiscussionId = location.state?.fromDiscussion;

  const token = localStorage.getItem('token');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

// détection RTL
const isRTL = document.documentElement.dir === 'rtl' || i18n.language === 'ar';

const [birthSettingsOpen, setBirthSettingsOpen] = useState(false);

const saveSetting = async (key, value) => {
  try {
    await api.put(`${API_URL}/api/profil/settings`,
      { [key]: value },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setSavedKey(key);                          // ← déclenche le feedback
    setTimeout(() => setSavedKey(null), 2000); // ← disparaît après 2s
  } catch (e) {
    console.error(`Erreur sauvegarde ${key}`, e);
    setSavedKey(`error_${key}`);               // ← feedback erreur
    setTimeout(() => setSavedKey(null), 3000);
  }
};

// Composant réutilisable
const SaveFeedback = ({ settingKey, savedKey }) => {
  if (savedKey === `error_${settingKey}`) return (
    <span style={{ fontSize: '11px', color: '#f44336', marginLeft: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}>
      <i className="ti ti-alert-circle" style={{ fontSize: '13px' }} aria-hidden="true" />
      {t('settings.save_error')}
    </span>
  );
  if (savedKey !== settingKey) return null;
  return (
    <span style={{
      fontSize: '11px', color: '#2ecc71', marginRight: '8px',
      display: 'flex', alignItems: 'center', gap: '4px',
      animation: 'fadeInSave 0.2s ease',
    }}>
      <i className="ti ti-check" style={{ fontSize: '13px' }} aria-hidden="true" />
      
    </span>
  );
};
const themes = [
  {
    key: 'light',
    label: t('settings.theme_clair'),
    dot: '#ffffff', dotBorder: '#ccc',
    preview: {
      bg: '#f9f9f9',
      toolbar: '#1976d2', toolbarText: '#fff',
      liBg: '#ffffff', liBorder: '#ddd',
      creatorColor: '#3498db',
      titleColor: '#2ecc71',
      previewColor: '#666',
      dateColor: '#666',
      btn: '#4caf50',
      addBtn: '#2ecc71',
    }
  },
{
    key: 'france',
    label: t('settings.theme_france'),
    dot: '#002395', dotBorder: '#ED2939',
    preview: {
      bg: '#f0f3fa',
      toolbar: '#1a3a8c', toolbarText: '#fff',
      liBg: '#ffffff', liBorder: '#c5cfe8',
      creatorColor: '#E1000F',
      titleColor: '#000091',
      previewColor: '#5a6080',
      dateColor: '#5a6080',
      btn: '#002395',
      addBtn: '#002395',
    }
  },
  {
    key: 'warm',
    label: t('settings.theme_chaud'),
    dot: '#f6f1ea', dotBorder: '#d7c7b5',
    preview: {
      bg: '#f6f1ea',
      toolbar: '#8d6e63', toolbarText: '#ffffff',
      liBg: '#fffaf3', liBorder: '#e3d7c9',
      creatorColor: '#8d6e63',
      titleColor: '#6b8e23',
      previewColor: '#5a4a3f',
      dateColor: '#8a7a6d',
      btn: '#8d6e63',
      addBtn: '#8d6e63',
    }
  },
  {
    key: 'dark',
    label: t('settings.theme_sombre'),
    dot: '#121212', dotBorder: '#444',
    labelColor: '#e0e0e0',
    preview: {
      bg: '#121212',
      toolbar: '#0d47a1', toolbarText: '#fff',
      liBg: '#2a2a2a', liBorder: '#444',
      creatorColor: '#64b5f6',
      titleColor: '#81d4fa',
      previewColor: '#999',
      dateColor: '#999',
      btn: '#388e3c',
      addBtn: '#388e3c',
    }
  },
  
  {
    key: 'midnight',
    label: t('settings.theme_midnight'),
    dot: '#7c3aed', dotBorder: '#a78bfa',
    labelColor: '#ddd6fe',
    preview: {
      bg: '#0f0f1a',
      toolbar: '#1e1b4b', toolbarText: '#c4b5fd',
      liBg: '#1e1b4b', liBorder: '#2e2760',
      creatorColor: '#7c3aed',
      titleColor: '#c4b5fd',
      previewColor: '#6d5fa6',
      dateColor: '#6d5fa6',
      btn: '#7c3aed',
      addBtn: '#7c3aed',
    }
  },
  {
    key: 'slate',
    label: t('settings.theme_slate'),
    dot: '#292524', dotBorder: '#78716c',
    preview: {
      bg: '#fafaf8',
      toolbar: '#292524', toolbarText: '#fafaf8',
      liBg: '#ffffff', liBorder: '#d6d3d1',
      creatorColor: '#78716c',
      titleColor: '#292524',
      previewColor: '#78716c',
      dateColor: '#78716c',
      btn: '#292524',
      addBtn: '#292524',
    }
  },
  {
    key: 'forest',
    label: t('settings.theme_forest'),
    dot: '#15803d', dotBorder: '#86efac',
    preview: {
      bg: '#f0fdf4',
      toolbar: '#14532d', toolbarText: '#dcfce7',
      liBg: '#ffffff', liBorder: '#bbf7d0',
      creatorColor: '#16a34a',
      titleColor: '#15803d',
      previewColor: '#4ade80',
      dateColor: '#4ade80',
      btn: '#15803d',
      addBtn: '#15803d',
    }
  },
  {
    key: 'ember',
    label: t('settings.theme_ember'),
    dot: '#c2410c', dotBorder: '#fb923c',
    labelColor: '#fed7aa',
    preview: {
      bg: '#1a0a00',
      toolbar: '#7c2d12', toolbarText: '#fed7aa',
      liBg: '#27150a', liBorder: '#431407',
      creatorColor: '#c2410c',
      titleColor: '#fb923c',
      previewColor: '#9a3412',
      dateColor: '#9a3412',
      btn: '#c2410c',
      addBtn: '#c2410c',
    }
  },
  {
    key: 'honey',
    label: t('settings.theme_honey'),
    dot: '#b45309', dotBorder: '#fcd34d',
    preview: {
      bg: '#fffbf0',
      toolbar: '#92400e', toolbarText: '#fef3c7',
      liBg: '#ffffff', liBorder: '#fde68a',
      creatorColor: '#d97706',
      titleColor: '#b45309',
      previewColor: '#b45309',
      dateColor: '#b45309',
      btn: '#b45309',
      addBtn: '#b45309',
    }
  },
  {
    key: 'ocean',
    label: t('settings.theme_ocean'),
    dot: '#0369a1', dotBorder: '#38bdf8',
    labelColor: '#e0f2fe',
    preview: {
      bg: '#0a1628',
      toolbar: '#0c4a6e', toolbarText: '#e0f2fe',
      liBg: '#082f49', liBorder: '#0c4a6e',
      creatorColor: '#0369a1',
      titleColor: '#38bdf8',
      previewColor: '#0369a1',
      dateColor: '#0369a1',
      btn: '#0369a1',
      addBtn: '#0369a1',
    }
  },
];

// État du carrousel (à ajouter avec tes autres useState)
const [carouselIndex, setCarouselIndex] = useState(
  themes.findIndex(t => t.key === theme) || 0
);
const touchStartX = useRef(0);

const goTo = (i) => {
  setCarouselIndex(Math.max(0, Math.min(themes.length - 1, i)));
};

const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};

const handleTouchEnd = (e) => {
  const dx = e.changedTouches[0].clientX - touchStartX.current;
  if (Math.abs(dx) > 40) {
    // En RTL, swiper vers la gauche = thème suivant (sens inversé)
    goTo(carouselIndex + (isRTL ? (dx > 0 ? 1 : -1) : (dx < 0 ? 1 : -1)));
  }
};

const handleSelectTheme = (key) => {
  setTheme(key);
  localStorage.setItem('theme', key);
  document.documentElement.setAttribute('data-theme', key);
};


//const themes = ['light', 'warm', 'soft', 'dark'];


const [user, setUser] = useState(null);
const [autoDeleteAfter, setAutoDeleteAfter] = useState(
  user?.settings?.autoDeleteAfter ?? null
);


const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
const [switchChecked, setSwitchChecked] = useState(false);
const [show2FASetup, setShow2FASetup] = useState(false);
const [showDisable2FAModal, setShowDisable2FAModal] = useState(false);

const getTTLLabel = (value) => {
  if (!value) return t('duree.jamais');
  if (value === 365) return t('duree.an', { count: 1 });
  return t('duree.jour', { count: value });
};

const TTL_OPTIONS = [
  { value: null, icon: 'ti-infinity'      },
  { value: 1,    icon: 'ti-sun'           },
  { value: 7,    icon: 'ti-calendar-week' },
  { value: 30,   icon: 'ti-calendar-month'},
  { value: 90,   icon: 'ti-calendar-time' },
  { value: 365,  icon: 'ti-calendar-stats' },
].map(opt => ({ ...opt, label: getTTLLabel(opt.value) }));

useEffect(() => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    setUser(JSON.parse(storedUser));
  }
}, []);


useEffect(() => {
  const fetchMe = async () => {
    try {
      const res = await api.get('/api/users/me');
      setUser(res.data);
// setHasRecovery(!!res.data?.e2eeRecovery?.phraseHash);
setHasRecovery(!!res.data?.e2eeRecovery?.encryptedPrivateKey);

     // localStorage.setItem('user', JSON.stringify(res.data)); // cache optionnel
    } catch (err) {
      console.error(err);
    }
  };

  fetchMe();
}, []);


//const [show2FASetup, setShow2FASetup] = useState(false);

useEffect(() => {
  if (!socket) return;

  const handleStatus = (data) => {
    //console.log("📡 userStatusChanged :", data);
  };

  socket.on("userStatusChanged", handleStatus);
  return () => socket.off("userStatusChanged", handleStatus);
}, [socket]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get(`${API_URL}/api/profil/settings`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUsername(res.data.username);
setInitialUsername(res.data.username);
        //setEmail(res.data.email);
//setNewPassword(res.data.newPassword);
setAllowContacts(res.data.settings?.allowContacts ?? false);
setShowEmail(res.data.settings?.showEmail ?? true);
setShowPhone(res.data.settings?.showPhone ?? true);
setShowBirthDate(res.data.settings?.showBirthDate ?? true);
setShowBirthDateSimple(res.data.settings?.showBirthDateSimple ?? true);
setShowAge(res.data.settings?.showAge ?? true);
setShowNotifInvit(res.data.settings?.showNotifInvit ?? true);
setShowNotifMessage(res.data.settings?.showNotifMessage ?? true);

setAutoTranslate(res.data.settings?.autoTranslate ?? true);
setAutoDeleteAfter(res.data.settings?.autoDeleteAfter ?? null);
      } catch (err) {
        console.error('Erreur lors du chargement des paramètres :', err);
      }
    };
    fetchSettings();
  }, [API_URL, token]);
const hasUnsavedChanges =
  username !== initialUsername || newPassword !== initialPassword;

  const handleSave = async () => {
  if (newPassword && passwordErrors.length > 0) {
    setError(t('password.faible'));
    return;
  }
  if (newPassword && !currentPassword) {
    setError(t('settings.current_password_required'));
    return;
  }
  setSuccess('');
  setError('');
  try {
    await api.put(`${API_URL}/api/profil/settings`, {
      allowContacts,
      showEmail,
      showPhone,
      showBirthDate,
      showBirthDateSimple,
      showAge,
      showNotifInvit,
      showNotifMessage,
      autoTranslate,
      autoDeleteAfter
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    await api.put(`${API_URL}/api/profil/userinfo`, {
      username,
      ...(newPassword ? { newPassword, currentPassword } : {}),
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (newPassword) {
      localStorage.clear();
      localStorage.setItem('verifiedMessage', t('settings.password_changed_relogin'));
      window.location.hash = '#/connexion';
      return;
    }

    setInitialUsername(username);
    setNewPassword('');
    setCurrentPassword('');
    setSuccess(t('settings.succes'));

  } catch (err) {
    console.error(err);
    const code = err.response?.data?.code;
    const message = err.response?.data?.message;
    setError(code ? t(code) : (message || t('settings.error')));
    setSuccess('');
  }
};

const navigate = useNavigate();
//const [socket, setSocket] = useState(null);
//const [user, setUser] = useState(null);

const handleOpenRecoverySetup = async () => {
  try {
    const identityKey = await signalStore.get('identityKey');

    if (!identityKey?.privKey) {
      setError('Clé de chiffrement introuvable sur cet appareil.');
      return;
    }

    setPrivateKey(identityKey.privKey);
    setShowRecoverySetup(true);

  } catch (err) {
    console.error('❌ Erreur préparation récupération :', err);
    setError('Impossible de préparer la récupération.');
  }
};

const handleRecoveryPhraseConfirm = async (phrase) => {
  try {
    const encryptedData = await encryptPrivateKey(
      privateKey,
      phrase
    );

    await api.post(
      `${API_URL}/api/e2ee/recovery/setup`,
      encryptedData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    setHasRecovery(true);
    setShowRecoverySetup(false);

    // Mise à jour locale de l'utilisateur
    const updatedUser = {
      ...user,
      e2eeRecovery: {
        ...encryptedData
      }
    };

    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));

    setSuccess(t('settings.recovery_saved'));

  } catch (err) {
    console.error('❌ Erreur sauvegarde récupération :', err);
    throw err;
  }
};

const handleDeleteAccount = async () => {
  const { alert, confirm } = prompt;
  setSuccess('');
  setError('');

  const confirmed = await confirm(t('settings.alertedeleteAccount'));
  if (!confirmed) return;

  try {
    await api.delete(`${API_URL}/api/profil/delete`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    // Option 1 : toast/alerte AVANT logout
    alert(t('settings.succesdelete'));

    // Option 2 : passer un état à la route connexion
    // cleanupAndLogout(setUser, socket, (path) => navigate(path, { state: { message: t('settings.succesdelete') } }));

    cleanupAndLogout(setUser, socket, navigate);

  } catch (err) {
    console.error('Erreur lors de la suppression du compte :', err);
    alert("Une erreur s'est produite lors de la suppression du compte.");
  }
};

const handleBackToDiscussions = () => {
    if (fromDiscussionId) {
      // Revenir à la discussion fullscreen
      navigate('/', {
        state: { reopenDiscussionId: fromDiscussionId },
      });
    } else {
      navigate(-1); // comportement par défaut
    }
  };


  return (

  <div className="settings-container">

<div className="groupe1" >
<div style={{display: 'flex'}}><h2>{t('settings.language')}</h2>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.language_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
       

  </span>
</div>

    <div className="setting-group" >
  <div className="setting-item setting-lang">
  <LanguageSelector />
  </div>
  </div>

{/* Remplace la section thème dans le JSX */}
<h2 style={{ paddingTop: '20px' }}>{t('settings.theme')}</h2>
<div className="theme-carousel-wrap">
  <div
    className="theme-carousel-viewport"
    onTouchStart={handleTouchStart}
    onTouchEnd={handleTouchEnd}
  >
    <div
      className="theme-carousel-track"
      style={{
        transform: `translateX(-${carouselIndex * 100}%)`,
        direction: 'ltr',
      }}
    >
      {themes.map((th) => {
        const p = th.preview;
        const isActive = theme === th.key;
        return (
          <div key={th.key} className="theme-carousel-slide">

            {/* Label + badge actif */}
            <div className="theme-slide-label" style={{ color: th.labelColor || 'inherit', direction: isRTL ? 'rtl' : 'ltr' }}>
              <span className="theme-dot" style={{ background: th.dot, borderColor: th.dotBorder }} />
              {th.label}
              {isActive && (
                <span className="theme-active-badge">{t('settings.theme_active')}</span>
              )}
            </div>

            {/* Mini-preview cliquable */}
            <div
              className="theme-preview-card"
              onClick={() => handleSelectTheme(th.key)}
              style={{ background: p.bg, borderColor: p.liBorder, cursor: 'pointer' }}
            >
              {/* Toolbar */}
              <div
                className="theme-preview-toolbar"
                style={{ background: p.toolbar, color: p.toolbarText }}
              >
                <span style={{ fontSize: '10px' }}>💬</span>
                {th.label}
                <span style={{
                  marginLeft: 'auto',
                  background: p.addBtn,
                  color: '#fff',
                  borderRadius: '50%',
                  width: '16px', height: '16px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '12px', fontWeight: 'bold', flexShrink: 0,
                }}>+</span>
              </div>

              {/* Liste de 3 discussions fictives */}
              <div style={{ padding: '4px 0' }}>
                {[
  { creator: 'Alice', title: t('themes.title1'), preview: t('themes.preview1'), date: '12/04', isPublic: true,  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Alice' },
  { creator: 'Bob',   title: t('themes.title2'),  preview: t('themes.preview2'),    date: '11/04', isPublic: false, avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Bob' },
  { creator: 'Léa',  title: t('themes.title3'), preview: t('themes.preview3'), date: '10/04', isPublic: false, avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lea' },
].map((item, i) => (
  <div key={i} style={{
    display: 'flex', alignItems: 'center', gap: '6px',
    padding: '5px 8px',
    background: p.liBg,
    borderBottom: `0.5px solid ${p.liBorder}`,
  }}>
    {/* Avatar image */}
    <img
      src={item.avatar}
      alt={item.creator}
      style={{
        width: '24px', height: '24px', borderRadius: '50%',
        flexShrink: 0, objectFit: 'cover',
        border: `1px solid ${p.liBorder}`,
      }}
    />

                    {/* Infos */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <span style={{ fontSize: '9px', color: p.creatorColor, fontWeight: '600' }}>
                          {item.creator}
                        </span>
                        {item.isPublic && (
                          <span style={{ fontSize: '8px', color: p.toolbar }}>🌐</span>
                        )}
                      </div>
                      <div style={{ fontSize: '9px', color: p.titleColor, fontWeight: '500' }}>
                        {item.title}
                      </div>
                      <div style={{
                        fontSize: '8px', color: p.previewColor,
                        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                      }}>
                        {item.preview}
                      </div>
                    </div>

                    {/* Date */}
                    <span style={{ fontSize: '8px', color: p.dateColor, flexShrink: 0 }}>
                      {item.date}
                    </span>
                  </div>
                ))}
              </div>{/* fin liste discussions */}

            </div>{/* fin theme-preview-card */}

          </div> 
        );
      })}
    </div>{/* fin theme-carousel-track */}
  </div>{/* fin theme-carousel-viewport */}

  {/* Flèches + nom */}
  <div className="theme-carousel-nav">
    <button
      className="theme-arrow"
      onClick={() => goTo(carouselIndex + (isRTL ? 1 : -1))}
      disabled={isRTL ? carouselIndex === themes.length - 1 : carouselIndex === 0}
    >
      {isRTL ? '→' : '←'}
    </button>
    <span className="theme-carousel-name">{themes[carouselIndex].label}</span>
    <button
      className="theme-arrow"
      onClick={() => goTo(carouselIndex - (isRTL ? 1 : -1))}
      disabled={isRTL ? carouselIndex === 0 : carouselIndex === themes.length - 1}
    >
      {isRTL ? '←' : '→'}
    </button>
  </div>

  {/* Points de navigation */}
  <div className="theme-carousel-dots">
    {themes.map((_, i) => (
      <span
        key={i}
        className={`theme-nav-dot ${i === carouselIndex ? 'active' : ''}`}
        onClick={() => goTo(i)}
      />
    ))}
  </div>

</div>{/* fin theme-carousel-wrap */}

</div>
<div className="groupe2" >
<div style={{display: 'flex'}}>
<h2>{t('2fa.2fa')}</h2>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('2fa.explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
       
  </span>
</div>
<div className="setting-group">
<div className="setting-item">
   <span
    className="setting-label"
    style={{
      color: user?.twoFactor?.enabled ? '#27ae60' : '#e74c3c'
    }}
  >
    {user?.twoFactor?.enabled
      ? t('2fa.active')
      : t('2fa.inactive')}
  </span>


  <label className="switch">
  <input
  type="checkbox"
  checked={!!user?.twoFactor?.enabled}
  onChange={(e) => {
    const checked = e.target.checked;

    if (checked) {
      // ON → afficher setup
      setShow2FASetup(true);
      setSwitchChecked(true); 
    } else {
      // OFF → afficher modal de désactivation
      setShowDisable2FAModal(true);
    }
  }}
/>

  <span className="slider3"></span>
</label>



{show2FASetup && (
  <TwoFactorSetup
    onSuccess={(updatedUser) => {
  // ✅ Fusionner avec l'user existant au lieu de remplacer
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  const mergedUser = {
    ...currentUser,
    ...updatedUser,
    twoFactor: updatedUser.twoFactor
  };

  setUser(mergedUser);
  setTwoFactorEnabled(true);
  setSwitchChecked(true);
  setShow2FASetup(false);
  localStorage.setItem('user', JSON.stringify(mergedUser));
}}
    onCancel={() => {
      setSwitchChecked(false);
      setShow2FASetup(false);
    }}
  />
)}

{showDisable2FAModal && (
  <Disable2FAModal
    onSuccess={(updatedUser) => {
      // ✅ Fusion
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      const mergedUser = {
        ...currentUser,
        ...updatedUser,
        twoFactor: updatedUser.twoFactor
      };

      setUser(mergedUser);
      setTwoFactorEnabled(false);
      setSwitchChecked(false);
      setShowDisable2FAModal(false);
      localStorage.setItem('user', JSON.stringify(mergedUser));
    }}
    onClose={() => setShowDisable2FAModal(false)}
  />
)}
</div>
</div>
<div style={{display: 'flex'}}>
<h2 style={{ paddingTop: '0px' }}>
    {t('settings.recoveryTitle')}
  </h2>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('recoverybackup.introduction')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
       
  </span>
</div>
  <div className="setting-group">
    <div className="setting-item">
      <div style={{ flex: 1 }}>
        
          

        <div style={{
          fontSize: '14px',
         color: hasRecovery ? '#27ae60' : '#e74c3c',
          marginTop: '6px',
          lineHeight: '1.5'
        }}>
          {hasRecovery
            ? t('settings.recoveryConfigured')
            : t('settings.recoveryNotConfigured')
          }
        </div>
      </div>

      <button
  type="button"
  onClick={() => navigate('/recovery')}
  style={{
    marginLeft: '12px',
    padding: '8px 12px',
    border: 'none',
    borderRadius: '6px',
    background: 'var(--toolbar-bg)',
    color: '#fff',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  }}
>
  {hasRecovery
    ? t('settings.recoveryChange')
    : t('settings.recoveryConfigure')}
</button>
    </div>
  </div>



</div>
<div className="groupe3" >
<div style={{display: 'flex'}}><h2>{t('settings.translate')}</h2>

<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.translate_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
        
  </span>
</div>

<div className="setting-group">
<div className="setting-item">
  <span className="setting-label">{t('settings.autoTranslate')}</span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="autoTranslate" savedKey={savedKey} />
  <label className="switch">
    <input
      type="checkbox"
      checked={autoTranslate}
      onChange={() => {
  const val = !autoTranslate;
  setAutoTranslate(val);
  saveSetting('autoTranslate', val); // ← immédiat

}}
    />
    <span className="slider2"></span>
  </label>
</div>
</div>

</div>

    <h2 style={{ paddingTop: '20px' }}>{t('settings.privacyTitle')}</h2>
    <div className="setting-group">
<div className="setting-item">
  <span className="setting-label">{t('settings.allowContacts')}</span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="allowContacts" savedKey={savedKey} />
  <label className="switch">
    <input
      type="checkbox"
      checked={allowContacts}
      
onChange={() => {
  const val2 = !allowContacts;
  setAllowContacts(val2);
  saveSetting('allowContacts', val2); // ← immédiat
if (val2) {
    localStorage.removeItem('contactsModalDismissed'); // ← réactivation = reset
  }

}}
    />
    <span className="slider2"></span>
  </label>

</div>
</div>

      <div className="setting-item" style={{ display: 'flex' }}>
        <span className="setting-label" >{t('settings.showemail')}</span>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.email_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: 'orange' }} aria-hidden="true" />

  </span>

<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showEmail" savedKey={savedKey} />
        <label className="switch" style={{ marginLeft: 'auto' }}>
          <input
            type="checkbox"
            checked={showEmail}
            
onChange={() => {
  const val3 = !showEmail;
  setShowEmail(val3);
  saveSetting('showEmail', val3); // ← immédiat

}}


          />
          <span className="slider2"></span>
        </label>
	</div>

      </div>

      <div className="setting-item" style={{ display: 'flex' }}>
        <span className="setting-label">{t('settings.showphone')}</span>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.phone_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: 'orange' }} aria-hidden="true" />

  </span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showPhone" savedKey={savedKey} />
        <label className="switch" style={{ marginLeft: 'auto' }}>
          <input
            type="checkbox"
            checked={showPhone}
            
onChange={() => {
  const val4 = !showPhone;
  setShowPhone(val4);
  saveSetting('showPhone', val4); // ← immédiat

}}

          />
          <span className="slider2"></span>
        </label>
 	</div>
     
</div>

<div
  className="setting-item clickable"
  onClick={() => setBirthSettingsOpen(!birthSettingsOpen)} // ← toggle
>
  <span className="setting-label">
    {t('profile.birthdate')}
  </span>
  <span className="arrow" style={{
    display: 'inline-block',
    transition: 'transform 0.2s ease',
    transform: birthSettingsOpen ? 'rotate(90deg)' : 'rotate(0deg)', // ← rotation visuelle
  }}>›</span>
</div>

{/* Overlay pour fermer au clic extérieur */}
{birthSettingsOpen && (
  <div
    onClick={() => setBirthSettingsOpen(false)}
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 99,
    }}
  />
)}

<div className={`slide-page ${birthSettingsOpen ? 'open' : ''}`}
  style={{ zIndex: 100 }} // ← au-dessus de l'overlay
>
  <div className="slide-header">
    <button style={{ background: 'none' }} onClick={() => setBirthSettingsOpen(false)}>
      <i className="ti ti-arrow-back-up" style={{ fontSize: '20px', position: 'relative', top: '-10px', color: 'var(--text-color)' }} aria-hidden="true" />
    </button>
    <h2>{t('profile.birthdate')}</h2>
  </div>

  <div className="slide-content">

    {/* Date complète */}
    <div className="setting-item" style={{ display: 'flex' }}>
      <span className="setting-label">
        {t('settings.showbirthdate')}
      </span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showBirthDate" savedKey={savedKey} />
      <label className="switch" style={{ marginLeft: 'auto' }}>
        <input
          type="checkbox"
          checked={showBirthDate}
          onChange={() => {
  const val5 = !showBirthDate;
  setShowBirthDate(val5);
  saveSetting('showBirthDate', val5); // ← immédiat
}}

        />
        <span className="slider2"></span>
      </label>
</div>	
    </div>

    {/* Anniversaire */}
    <div className="setting-item" style={{ display: 'flex' }}>
      <span className="setting-label">
        {t('settings.showbirthdate_simple')}
      </span>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.birthdate_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
        
  </span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showBirthDateSimple" savedKey={savedKey} />

      <label className="switch" style={{ marginLeft: 'auto' }}>
        <input
          type="checkbox"
          checked={showBirthDateSimple}
          onChange={() => {
  const val6 = !showBirthDateSimple;
  setShowBirthDateSimple(val6);
  saveSetting('showBirthDateSimple', val6); // ← immédiat
}}

        />
        <span className="slider2"></span>
      </label>
</div>	
    </div>

    {/* Age */}
    <div className="setting-item" style={{ display: 'flex' }}>
      <span className="setting-label">
        {t('settings.showage')}
      </span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showAge" savedKey={savedKey} />
      <label className="switch" style={{ marginLeft: 'auto' }}>
        <input
          type="checkbox"
          checked={showAge}
          onChange={() => {
  const val7 = !showAge;
  setShowAge(val7);
  saveSetting('showAge', val7); // ← immédiat
}}

        />
        <span className="slider2"></span>
      </label>
	</div>
    </div>
</div>
</div>
</div>

<h2 style={{ paddingTop: '20px' }}>{t('settings.notifications')}</h2>
<div className="setting-group">
      <div className="setting-item">
        <span className="setting-label" >{t('settings.shownotif_invit')}</span>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.notif_invit_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
        
  </span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showNotifInvit" savedKey={savedKey} />

        <label className="switch" style={{ marginLeft: 'auto' }}>
          <input
            type="checkbox"
            checked={showNotifInvit}
            
onChange={() => {
  const val8 = !showNotifInvit;
  setShowNotifInvit(val8);
  saveSetting('showNotifInvit', val8); // ← immédiat
}}

          />
          <span className="slider2"></span>
        </label>
	</div>

      </div>
<div className="setting-item" style={{ display: 'flex' }}>
        <span className="setting-label">{t('settings.shownotif_message')}</span>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('settings.notif_message_explication')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />
        
  </span>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '5px' }}>
    <SaveFeedback settingKey="showNotifMessage" savedKey={savedKey} />
        <label className="switch" style={{ marginLeft: 'auto' }}>
          <input
            type="checkbox"
            checked={showNotifMessage}
            onChange={() => {
  const val9 = !showNotifMessage;
  setShowNotifMessage(val9);
  saveSetting('showNotifMessage', val9); // ← immédiat
}}

          />
          <span className="slider2"></span>
        </label>
     </div> 
</div>
</div>


  <div style={{ display: 'flex' }}>
    <h2>{t('duree.expiration')}</h2>
    <span
      className="info-bubble"
      onClick={() =>
        prompt.alert(
          <span dangerouslySetInnerHTML={{ __html: t('duree.settings_explication') }} />
        )
      }
    >
      <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#EA580C' }} aria-hidden="true" />
    </span>
  </div>

  <div className="setting-group">
<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '6px' }}>
  <SaveFeedback settingKey="autoDeleteAfter" savedKey={savedKey} />
</div>

    <div className="ttl-options">

      {TTL_OPTIONS.map(opt => (
        <div
          key={opt.value ?? 'null'}
          className={`ttl-option ${autoDeleteAfter === opt.value ? 'selected' : ''}`}
          onClick={() => {
            setAutoDeleteAfter(opt.value);
		saveSetting('autoDeleteAfter', opt.value);
            //setHasUnsavedChanges(true); // 👈 déclenche ton bouton flottant existant
          }}
        >
          <div className="ttl-option-left">
            <i className={`ti ${opt.icon} ttl-option-icon`} aria-hidden="true" />
            <span className="ttl-option-label">{opt.label}</span>

          </div>
          <div className="ttl-option-check">
            <i className="ti ti-check" aria-hidden="true" />
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

<div className="groupe5">

    <h2 style={{ paddingTop: '20px' }}>{t('settings.accountTitle')}</h2>
    <div className="setting-group">
<Alert type="error" message={error} />
    <Alert type="success" message={success} />

      <div className="setting-item">
        <label className="setting-label">{t('settings.username')}</label>
        <input
          className="setting-input username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

      </div>
{newPassword && (
  <div className="setting-item">
    <label className="setting-label">{t('settings.currentpassword')}</label>
    <input
      className="setting-input password"
      type="password"
      placeholder={t('settings.currentpassword_placeholder')}
      value={currentPassword}
      onChange={(e) => setCurrentPassword(e.target.value)}
    />
  </div>
)}
      <div className="setting-item">
  <label className="setting-label">{t('settings.password')}</label>
  <input
    className="setting-input password"
    type="password"
    placeholder={t('settings.newpassword')}
    value={newPassword}
    onChange={handleNewPasswordChange}
  />
  {newPassword && passwordErrors.length > 0 && (
    <ul style={{ fontSize: '12px', color: '#c0392b', paddingLeft: '18px' }}>
      {passwordErrors.map((err, i) => <li key={i}>{err}</li>)}
    </ul>
  )}
</div>

    </div>

<Alert type="error" message={error} />
    <Alert type="success" message={success} />

   
<div className="setting-group">
      <div className="setting-item">

    <button className="delete-account-button" onClick={handleDeleteAccount}>
<i className="ti ti-user-off" style={{ fontSize: '18px' }} />
      {t('settings.deleteAccount')}
    </button>
</div>
</div>
</div>
{/* Bouton flottant — à placer juste avant la fermeture du return */}
{hasUnsavedChanges && (
  <button
    onClick={handleSave}
    style={{
      position: 'fixed',
      bottom: '150px',
      right: '24px',
      zIndex: 1000,
      background: 'var(--toolbar-bg)',
      color: '#fff',
      border: 'none',
      borderRadius: '24px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '600',
      boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'opacity 0.2s ease',
    }}
  >
    <i className="ti ti-device-floppy" style={{ fontSize: '18px' }} />
    {t('settings.save')}
  </button>
)}
</div>

);

};

export default Settings;
